import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../Services/supabaseClient';
import { NavLink } from 'react-router-dom';
import styles from './Sidebar.module.css';

const LINKS = [
  ['/dashboard', 'Dashboard', '⌂'],
  ['/defaults', 'Defaults', '⚙'],
  ['/legal-documents', 'Legal Documents', '§'],
  ['/users', 'Users', '👤'],
  ['/photographers', 'Photographers', '📷'],
  ['/events', 'Events', '🏅'],
  ['/campaigns', 'Campaigns', '📣'],
  ['/photos', 'Photos', '🖼'],
  ['/survey', 'Survey', '✎'],
];

// Collapsed = icon rail (so the ops page gets the width); remembered per browser.
function readCollapsed() {
  try { return localStorage.getItem('sidebarCollapsed') === '1'; } catch { return false; }
}

export default function Sidebar({ operator = false }) {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(readCollapsed);
  const toggle = () => {
    setCollapsed((c) => {
      try { localStorage.setItem('sidebarCollapsed', c ? '0' : '1'); } catch { /* ignore */ }
      return !c;
    });
  };

  const handleLogout = async () => {
    await supabase.auth.signOut();
    localStorage.removeItem('a_access_token');
    navigate('/login');
    window.location.reload();
  };

  return (
    <div className={`${styles.sidebar} ${collapsed ? styles.collapsed : ''}`}>
      <div className={styles.header}>
        {!collapsed && <h2 className={styles.logo}>Admin</h2>}
        <button
          type="button"
          className={styles.toggle}
          onClick={toggle}
          aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          {collapsed ? '»' : '«'}
        </button>
      </div>
      <nav className={styles.nav}>
        {(operator ? LINKS.filter(([to]) => to === '/events') : LINKS).map(([to, label, icon]) => (
          <NavLink key={to} to={to} className={({ isActive }) => isActive ? styles.active : ''} title={label}>
            {collapsed ? <span aria-label={label}>{icon}</span> : label}
          </NavLink>
        ))}
      </nav>
      <button onClick={handleLogout} className={styles.logoutBtn} title="Logout">{collapsed ? '⏻' : 'Logout'}</button>
    </div>
  );
}
